// 🔐 accounts (09-30): the /api/auth calls. The session token rides ONLY the
// Authorization header of these calls, never a URL and never another endpoint
// (some dedicated backend functions allow only Content-Type in their CORS
// preflight, so a global header would break them). Every answer is JSON with
// `success`; a network failure answers { success:false, code:'network' }.
import { API_BASE_URL } from '../config/api';

const ENDPOINT = `${API_BASE_URL}/api/auth`;
const NETWORK = { success: false, code: 'network', error: 'Could not reach myspaice. Try again.' };

async function request(method, { op, params, body, token } = {}) {
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const init = { method, headers };
  let url = ENDPOINT;
  if (method === 'GET') {
    url += `?${new URLSearchParams({ op, ...(params || {}) }).toString()}`;
  } else {
    headers['Content-Type'] = 'application/json';
    init.body = JSON.stringify({ op, ...(body || {}) });
  }
  try {
    const res = await fetch(url, init);
    const json = await res.json().catch(() => null);
    return res.ok && json && typeof json === 'object' ? json : NETWORK;
  } catch (e) {
    return NETWORK;
  }
}

export const authConfig = () => request('GET', { op: 'config' });
export const authGoogle = (credential) => request('POST', { op: 'google', body: { credential } });
export const authMe = (token) => request('GET', { op: 'me', token });
export const authClaim = (token, { seats = [], agents = [] } = {}) => request('POST', { op: 'claim', body: { seats, agents }, token });
// R10 "Ask first": what this browser proves, by room + AI. Writes nothing.
export const authClaimPreview = (token, { seats = [], agents = [] } = {}) => request('POST', { op: 'claim', body: { seats, agents, preview: true }, token });
// "Remove" on /account: kind 'room' | 'agent'.
export const authUnlink = (token, { kind, id }) => request('POST', { op: 'unlink', body: { kind, id }, token });
// `room`, not game_id: see the backend's authApi.js header (the private-room gate).
export const authSeat = (token, room) => request('GET', { op: 'seat', params: { room }, token });
export const authSignOut = (token) => request('POST', { op: 'signout', token });
export const authSignOutAll = (token) => request('POST', { op: 'signout_all', token });
export const authDelete = (token) => request('POST', { op: 'delete', body: { confirm: 'delete' }, token });
